export default __webpack_public_path__ + "static/media/washupBirthday.b10d9506.png";